import SiteHeader from '../../components/feature/SiteHeader';
import Hero from './components/Hero';
import AnnualReview from './components/AnnualReview';
import EmailForm from './components/EmailForm';
import Services from './components/Services';
import ValueStack from './components/ValueStack';
import Guarantee from './components/Guarantee';
import WhoIsItFor from './components/WhoIsItFor';
import Transformations from './components/Transformations';
import BookingForm from './components/BookingForm';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Social from './components/Social';
import Subscribe from './components/Subscribe';
import Footer from './components/Footer';
import ExitIntentPopup from './components/ExitIntentPopup';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <SiteHeader />
      <Hero />
      <AnnualReview />
      <EmailForm />
      <Services />
      <ValueStack />
      <Guarantee />
      <WhoIsItFor />
      <Transformations />
      <BookingForm />
      <Testimonials />
      <FAQ />
      <Social />
      <Subscribe />
      <Footer />
      <ExitIntentPopup />
    </div>
  );
}
